const titles = {
	start: 'Make a payment',
	choosePaymentMethod: 'Choose a one-time payment method',
	useNewCard: 'Use a new card',
	confirmPayment: 'Confirm payment details',
	confirmOneTimePayment: 'Confirm payment details',
} as const;

export type DialogMakePaymentStep = keyof typeof titles;

export default titles;
